import React, { useState, useEffect } from 'react';
import { HomeContainer } from '../Components/Home/HomeContainer';
import DailyBriefing from '../Components/Home/DailyBriefing';
import { ResponsiveBar, ComputedDatum } from '@nivo/bar';
import { ResponsiveLine } from '@nivo/line';
import { ResponsivePie } from '@nivo/pie';
import { COLORS } from '../Styles/Colors';
import { mockData } from '../Data/MockData';
import { Widget, WidgetGrid, WidgetTitle, BackButton } from '../Styles/WidgetStyles';
import { BarItem, SubBarItem, DrillDownData } from '../Types';
import apiClient from '../Services/ApiClient';
import { TransactionUsage } from './TransactionUsage';

interface AssetStats {
  totalActive: number;
  checkedOut: number;
  needsRepair: number;
  needsService: number;
  avgRepairTime: number;
}

const HomePage: React.FC = () => {
  const [barData, setBarData] = useState<(BarItem | SubBarItem)[]>(mockData.barData.topLevel);
  const [barLevel, setBarLevel] = useState('topLevel');
  const [assetStats, setAssetStats] = useState<AssetStats | null>(null);

  // Fetch asset stats on mount
  useEffect(() => {
    const fetchAssetStats = async () => {
      try {
        const response = await apiClient('/api/assets/stats');
        const data = await response.json();
        setAssetStats(data);
      } catch (error) {
        console.error('Failed to fetch asset stats:', error);
      }
    };
    fetchAssetStats();
  }, []);

  const handleBarClick = (
    datum: ComputedDatum<BarItem | SubBarItem> & { color: string },
    event: React.MouseEvent<SVGRectElement>
  ) => {
    if (barLevel === 'topLevel') {
      const category = datum.indexValue as keyof DrillDownData;
      if (mockData.barData.drillDown[category]) {
        setBarData(mockData.barData.drillDown[category]);
        setBarLevel(category);
      }
    }
  };

  const handleBackClick = () => {
    if (barLevel !== 'topLevel') {
      setBarData(mockData.barData.topLevel);
      setBarLevel('topLevel');
    }
  };

  // Asset-related chart data
  const assetPieData = assetStats
    ? [
        { id: 'Checked Out', label: 'Checked Out', value: assetStats.checkedOut, color: COLORS.teal },
        {
          id: 'Available',
          label: 'Available',
          value: assetStats.totalActive - assetStats.checkedOut,
          color: COLORS.darkTeal,
        },
      ]
    : [];

  const assetBarData = assetStats
    ? [
        { category: 'Checked Out', value: assetStats.checkedOut },
        { category: 'Needs Repair', value: assetStats.needsRepair },
        { category: 'Needs Service', value: assetStats.needsService },
      ]
    : [];

  return (

    <TransactionUsage />

    // <HomeContainer>
    //   <DailyBriefing />
    //   <WidgetGrid>
    //     {/* Existing Widgets */}
    //     <Widget>
    //       <WidgetTitle>
    //         {barLevel === 'topLevel' ? 'Product Category Usage' : `${barLevel} Usage`}
    //       </WidgetTitle>
    //       {barLevel !== 'topLevel' && (
    //         <BackButton onClick={handleBackClick}>Back</BackButton>
    //       )}
    //       <ResponsiveBar
    //         data={barData}
    //         keys={['value']}
    //         indexBy={barLevel === 'topLevel' ? 'category' : 'subcategory'}
    //         margin={{ top: 10, right: 20, bottom: 150, left: 40 }}
    //         padding={0.3}
    //         colors={[COLORS.teal]}
    //         borderRadius={6}
    //         axisBottom={{
    //           tickRotation: -45,
    //           tickPadding: 5,
    //           tickSize: 5,
    //         }}
    //         axisLeft={{
    //           tickSize: 5,
    //           tickPadding: 5,
    //         }}
    //         enableLabel={false}
    //         onClick={handleBarClick}
    //         layout="vertical"
    //       />
    //     </Widget>
    //     <Widget>
    //       <WidgetTitle>Total Spend (USD)</WidgetTitle>
    //       <ResponsiveLine
    //         data={mockData.lineData}
    //         margin={{ top: 10, right: 20, bottom: 100, left: 50 }}
    //         xScale={{ type: 'point' }}
    //         yScale={{ type: 'linear', min: 0, max: 'auto' }}
    //         yFormat=" >-$,.2f"
    //         axisBottom={{
    //           tickRotation: -45,
    //           tickPadding: 5,
    //           tickSize: 5,
    //         }}
    //         axisLeft={{
    //           tickSize: 5,
    //           tickPadding: 5,
    //           format: ' >-$,.0f',
    //         }}
    //         colors={[COLORS.teal]}
    //         pointSize={10}
    //         pointColor={{ theme: 'background' }}
    //         pointBorderWidth={2}
    //         pointBorderColor={{ from: 'serieColor' }}
    //         useMesh={true}
    //         curve="monotoneX"
    //         areaOpacity={0.2}
    //       />
    //     </Widget>
    //     <Widget>
    //       <WidgetTitle>Inventory by Category</WidgetTitle>
    //       <ResponsivePie
    //         data={mockData.pieData}
    //         margin={{ top: 20, right: 60, bottom: 20, left: 60 }}
    //         innerRadius={0.5}
    //         padAngle={2}
    //         cornerRadius={6}
    //         colors={{ datum: 'data.color' }}
    //         arcLinkLabelsSkipAngle={10}
    //         arcLinkLabelsTextColor="#333333"
    //         arcLinkLabelsThickness={2}
    //         arcLinkLabelsColor={{ from: 'color' }}
    //         arcLinkLabelsOffset={6}
    //         arcLinkLabelsDiagonalLength={16}
    //         arcLinkLabelsStraightLength={12}
    //         borderWidth={1}
    //         borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
    //       />
    //     </Widget>

    //     {/* New Asset Widgets */}
    //     <Widget>
    //       <WidgetTitle>
    //         Total Active Assets: {assetStats ? assetStats.totalActive : 'Loading...'}
    //       </WidgetTitle>
    //       {assetStats && (
    //         <ResponsivePie
    //           data={assetPieData}
    //           margin={{ top: 20, right: 60, bottom: 20, left: 60 }}
    //           innerRadius={0.5}
    //           padAngle={2}
    //           cornerRadius={6}
    //           colors={{ datum: 'data.color' }}
    //           arcLinkLabelsSkipAngle={10}
    //           arcLinkLabelsTextColor="#333333"
    //           arcLinkLabelsThickness={2}
    //           arcLinkLabelsColor={{ from: 'color' }}
    //           arcLinkLabelsOffset={6}
    //           arcLinkLabelsDiagonalLength={16}
    //           arcLinkLabelsStraightLength={12}
    //           borderWidth={1}
    //           borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
    //         />
    //       )}
    //     </Widget>
    //     <Widget>
    //       <WidgetTitle>Asset Status</WidgetTitle>
    //       {assetStats && (
    //         <ResponsiveBar
    //           data={assetBarData}
    //           keys={['value']}
    //           indexBy="category"
    //           margin={{ top: 10, right: 20, bottom: 50, left: 40 }}
    //           padding={0.3}
    //           colors={[COLORS.teal]}
    //           borderRadius={6}
    //           axisBottom={{
    //             tickRotation: -45,
    //             tickPadding: 5,
    //             tickSize: 5,
    //           }}
    //           axisLeft={{
    //             tickSize: 5,
    //             tickPadding: 5,
    //           }}
    //           enableLabel={false}
    //           layout="vertical"
    //         />
    //       )}
    //     </Widget>
    //     <Widget>
    //       <WidgetTitle>Average Repair Time (Days)</WidgetTitle>
    //       {assetStats ? (
    //         <div style={{ fontSize: '24px', textAlign: 'center', padding: '20px' }}>
    //           {assetStats.avgRepairTime?.toFixed(1)}
    //         </div>
    //       ) : (
    //         <div>Loading...</div>
    //       )}
    //     </Widget>
    //   </WidgetGrid>
    // </HomeContainer>
  );
};

export default HomePage;